import * as React from 'react';
const CistiteIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1,.prefix__cls-2{stroke:${secondaryColor ||
        '#ffcf38'};fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}.prefix__cls-2{stroke:${primaryColor ||
        '#282828'}}`}</style>
    </defs>
    <path
      d="M136.45 64.17a49 49 0 0 1-2.92 3.17c-1.5 1.5-3.09 2.9-4.74 4.17-.83.66-1.69 1.25-2.57 1.81-.95.6-2.18.62-3.12 0-6.11-3.98-14.21-6.41-23.1-6.41s-16.99 2.43-23.1 6.41c-.94.61-2.17.59-3.12 0-.88-.56-1.74-1.15-2.57-1.81a50 50 0 0 1-4.74-4.17c-1-1-2-2.09-2.92-3.17M60.03 68.92c.66.85 1.33 1.67 2.04 2.49 1.55 1.79 3.21 3.48 5 5.08.34.31.69.62 1.05.91 1.18.98 1.42 2.65.59 3.94-2.03 3.16-3.16 6.68-3.16 10.39 0 11.62 11.09 21.36 26.07 24.06 2.36.43 4.23 2.43 4.25 4.83v.05c0 2.76-1.38 2.76-1.38 5.51s2.76 5.19 2.76 8.27v1.38M132.59 83.7c-.37-.8-.81-1.58-1.31-2.36-.83-1.28-.58-2.96.59-3.94.36-.29.7-.59 1.05-.91 1.79-1.6 3.46-3.29 5-5.07.7-.83 1.38-1.65 2.04-2.49M102.76 135.83v-1.38c0-3.09 2.76-5.51 2.76-8.27s-1.38-2.76-1.38-5.51v-.06c.01-1.31.58-2.51 1.47-3.39"
      className="prefix__cls-2"
    />
    <circle cx={115.37} cy={97.45} r={16.54} className="prefix__cls-1" />
    <path
      d="m129.68 105.92 9.07 9.07a4.146 4.146 0 0 1 0 5.85h0a4.146 4.146 0 0 1-5.85 0l-9.08-9.08M111.64 94.34c-1.61 1.61-3.8 2.05-4.87.97s-.64-3.26.97-4.87 3.8-2.05 4.87-.97.64 3.26-.97 4.87M113.26 107.54c-2.11-.88-3.34-2.74-2.75-4.14s2.77-1.83 4.88-.95 3.34 2.73 2.75 4.14c-.59 1.4-2.77 1.83-4.88.95"
      className="prefix__cls-1"
    />
    <circle cx={122.48} cy={95.15} r={2.76} className="prefix__cls-1" />
  </svg>
);
export default CistiteIcon;
